import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import utils from '@/lib/utils'
import _ from 'lodash'

const lazyRulesValues = [true, false, 'ondemand']

export default {
  props: {
    // 参照QSelect的属性
    value: {
      // required: true,
      type: [Number, String, Array]
    },
    useInput: {
      type: Boolean,
      default: undefined // 直接写 useInput: Boolean 会导致 $props.useInput 默认值为false, undefined表示用户未设置
    },
    hideSelected: {
      type: Boolean,
      default: undefined
    },
    fillInput: {
      type: Boolean,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    clearIcon: {
      type: String,
      default: 'close'
    },
    lazyRules: {
      type: [Boolean, String],
      validator: v => lazyRulesValues.includes(v),
      default: true
    },
    noErrorIcon: {
      type: Boolean,
      default: true
    },
    emitValue: {
      type: Boolean,
      default: true
    },
    optionLabel: {
      type: [String, Function],
      default: 'label'
    },
    mapOptions: {
      type: Boolean,
      default: true
    },
    transitionShow: {
      type: String,
      default: 'jump-up'
    },
    transitionHide: {
      type: String,
      default: 'jump-up'
    },
    bottomSlots: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: null
    },
    label: String,
    options: Array,
    labelColor: {
      type: String,
      default: 'black'
    },
    optionsSelectedClass: {
      type: String,
      default: 'app-option-selected'
    },
    // 新增属性
    whiteList: [Array, Function],
    blackList: [Array, Function]
  },
  // mounted () {
  //   this.$refs.input && this.$refs.input.$on('focus', this.onFocus)
  // },
  computed: {
    allOptions () {
      return this.options
    },
    whiteListSet () {
      return this.whiteList instanceof Array ? new Set(this.whiteList) : null
    },
    blackListSet () {
      return this.blackList instanceof Array ? new Set(this.blackList) : null
    },
    validOptions () {
      if (this.whiteList || this.blackList) {
        return this.allOptions?.filter(item => this.validateWBList(item)) ?? []
      } else {
        return this.allOptions ?? []
      }
    }
  },
  watch: {
    validOptions (newVal) {
      this.selectOptions = newVal
    },
    selectOptions (newVal) {
      if (!_.isNil(this.value) && !newVal?.find(item => item.value === this.value)) {
        this.$emit('input', null)
      }
    },
    value (newVal) {
      if (newVal) {
        // this.filter(null)
        this.onFilterOptions(null, func => func())
      }
    }
  },
  methods: {
    filter (val) {
      this.$refs.input && this.$refs.input.filter(val)
    },
    slotSelectedItem (createElement) {
      const that = this
      return function (scope) {
        const { meta, data } = scope.opt ?? { }
        return createElement('span', {
          style: (meta ?? data)?.labelStyle
        }, that.$refs.input?.getOptionLabel(scope.opt))
      }
    },
    slotOption (createElement) {
      const that = this
      return function (scope) {
        const { color, icon, meta, data } = scope.opt ?? { }
        const itemClass = {}
        if (color) {
          itemClass[`text-${color}`] = !!color
        } else {
          itemClass['text-primary'] = true
        }
        return createElement(QItem, {
          key: scope.index,
          class: itemClass,
          props: scope.itemProps,
          on: scope.itemEvents
        }, [
          icon ? createElement(QItemSection, {
            props: {
              avatar: true
            }
          }, [
            createElement(QAvatar, {
              props: {
                icon: icon,
                textColor: color ?? 'primary'
              }
            })
          ]) : null,
          createElement(QItemSection, [
            createElement(QItemLabel, {
              style: (meta ?? data)?.labelStyle,
              domProps: {
                [scope.sanitize ? 'textContent' : 'innerHTML']: that.$refs.input?.getOptionLabel(scope.opt)
              }
            })
          ])
        ])
      }
    },
    onFilterOptions (val, update) {
      if (utils.isWhitespaceString(val)) {
        update(() => {
          this.selectOptions = this.validOptions
        })
      } else {
        val = val.trim().toUpperCase()
        const filteredOptions = this.validOptions.filter(item =>
          this.$refs.input?.getOptionLabel(item)?.trim()?.toUpperCase()?.includes(val) ||
          item.textPy?.trim()?.toUpperCase()?.includes(val))
        // 过滤到只有一条记录时, 自动选中
        let autoPick = false
        let emitValue = null
        if (filteredOptions.length === 1 && this.$refs.input) {
          const autoPickOption = filteredOptions[0]
          if (!this.$refs.input.isOptionSelected(autoPickOption) && this.$refs.input.getOptionLabel(autoPickOption)?.trim()?.toUpperCase() === val) {
            autoPick = true
            emitValue = this.$refs.input.getEmittingOptionValue(autoPickOption)
          }
        }
        update(() => {
          this.selectOptions = filteredOptions
          if (autoPick) {
            this.$emit('input', emitValue)
            setTimeout(() => {
              this.$refs.input && this.$refs.input.hidePopup()
            }, 200)
          }
        })
      }
    },
    hidePopup () {
      this.$refs.input && this.$refs.input.hidePopup()
    },
    // onFocus () {
    //   this.$refs.input && this.$refs.input.showPopup()
    // },
    validateWBList (item) {
      return (this.whiteList ? (this.whiteListSet ? this.whiteListSet.has(item.value) : this.whiteList(item)) : true) &&
        (this.blackList ? (this.blackListSet ? !this.blackListSet.has(item.value) : !this.blackList(item)) : true)
    },
    getOptionByValue (val) {
      return this.$refs.input && this.allOptions?.find(item => this.$refs.input.getOptionValue(item) === val)
    }
  }
}
